/**
 * 
 * Utility to load the scripts (internal / external) within the component
 */
 import * as cheerio from 'cheerio'
const loadScript = ({ src, nonce = '', defer=false, async=false }) =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    if (nonce) {
      script.setAttribute('data-csp-nonce', nonce)
    }
    if(defer) script.defer = defer;
    if(async) script.async = async
    script.addEventListener('load', resolve)
    script.addEventListener('error', reject)
    document.body.appendChild(script)
  })

const extractAndLoadScripts = async (content='') => {
  const scriptRegex = /<script (.*)>(.*)<\/script>/gi
  let scriptTags=content.match(scriptRegex);
  let scripts = []
  if(scriptTags && scriptTags.length > 0){
    for (const scriptTag of scriptTags) {
      let $ = cheerio.load(scriptTag)
      $('script').each(function() {
      if($(this).attr('src')) scripts.push($(this).attr('src'))
      });
    }
    for (const src of scripts) {
      try{
        await loadScript({src})
      }catch(err){
        console.log(`Error loading: ${src}`)
      }
    }
  }      
}

export { loadScript, extractAndLoadScripts }
